//Component
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Login from '../pages/authentication/Login';
import Layout from '../shared/Layout';
import ResetPassword from '../pages/authentication/ResetPassword';
import UnAuthorized from '../pages/authentication/UnAuthorized';

const LayoutNavigation = (props) => {
    return (
        
        <Router>
            <React.Suspense fallback={null}>
                <Routes>
                    <Route name="Layout" path="/" element={<Layout componentRoutes={props.componentRoutes} />}>
                        {props.componentRoutes && props.componentRoutes.map((route, idx) => {
                            return route.component && (
                                <Route
                                    key={idx}
                                    path={route.path}
                                    element={<route.component authDetails={route.authDetails} />} />
                            )
                        })}
                    </Route>
                     <Route exact name="Login" path="/login" element={<Login authDetails={props.authDetails} />} />
                     <Route exact name="UnAuthorized" path="/UnAuthorized" element={<UnAuthorized />} />
                    <Route exact name="ResetPassword" path="/ResetPassword" element={<ResetPassword />} />
                    <Route  path="*" element={<UnAuthorized />} />
                </Routes>
            </React.Suspense>
        </Router>
    )
}

export default LayoutNavigation;